var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
// Imports
import Vue from "vue";
import Component from "vue-class-component";
import { Rounds } from "../../../modules/rounds";
import { Players } from "../../../modules/players";
import { Utilities } from "../../../services/utilities";
// Define vue parameters
var ListRoundsComponent = /** @class */ (function (_super) {
    __extends(ListRoundsComponent, _super);
    /**
     * Setup the child and parent class
     */
    function ListRoundsComponent() {
        var _this = _super.call(this) || this;
        // Create a players instance
        _this.player = new Players();
        _this.rounds = new Rounds();
        return _this;
    }
    /**
     * Component setup on mount
     */
    ListRoundsComponent.prototype.mounted = function () {
        var _this = this;
        // Get all rounds for default range
        this.rounds.getAll(1, 1).then(function (r) {
            _this.$data.roundData = r;
        });
        // Get player stats
        this.player.get().then(function (r) {
            _this.$data.playerData = r;
        });
    };
    /**
     * Delete a handicap and update the view upon deletion
     */
    ListRoundsComponent.prototype.deleteEntry = function (roundId, dataIndex) {
        var _this = this;
        Utilities.confirm("Are you sure you want to delete this round?").then(function () {
            // Delete the handicap
            _this.rounds["delete"](roundId).then(function (r) {
                // Remove the handicap from the $data object
                _this.$delete(_this.$data.roundData.rounds, dataIndex);
            });
        });
    };
    /**
     * Load more entries
     */
    ListRoundsComponent.prototype.showMore = function () {
        var _this = this;
        // The offset is used to paginate through entries
        var offset = this.$data.roundData.rounds.length + 1;
        // Append new entries to handicap data with offset from index
        this.rounds.getAll(offset, this.$data.roundData.to + 10).then(function (r) {
            _this.$data.roundData.rounds.push(r.rounds[0]);
            // Update metadata
            _this.$data.roundData.from = r.from;
            _this.$data.roundData.to = r.to;
        });
    };
    ListRoundsComponent = __decorate([
        Component({
            data: function () {
                return {
                    roundData: null,
                    playerData: null
                };
            }
        })
        // Define the component code
    ], ListRoundsComponent);
    return ListRoundsComponent;
}(Vue));
export default ListRoundsComponent;
